import React from "react";
import StaticPage from "../../components/StaticPage";

const GenericMedicines = () => (
    <StaticPage
        title="Understanding Generic Medicines"
        crumb="Generic Medicines"
        testId="page-generic"
        intro="Generic medicines contain the same active ingredient, in the same dose, with the same dosage form and route of administration as the branded original — but typically cost 60–90% less."
        sections={[
            {
                heading: "Are they as effective?",
                body: "Yes. Generic versions are evaluated for bioequivalence to the original brand under strict CDSCO/USFDA standards. The active molecule, strength and absorption profile must fall within a narrow regulatory tolerance.",
            },
            {
                heading: "Why are they cheaper?",
                body: "The original manufacturer recovers R&D, trials, and marketing costs through patent-protected pricing. Once the patent expires, multiple licensed manufacturers can produce the same molecule, and competition drives price down without compromising quality.",
            },
            {
                heading: "How does PILLS handle generics?",
                body: "Every product page surfaces the cheapest verified generic alternative (look for the 'Substitutes' section). If your doctor's prescription doesn't object, you can save substantially by switching. Always check with your prescribing physician before making the swap.",
            },
            {
                heading: "Quality assurance",
                body: "All generic SKUs on PILLS are sourced from WHO-GMP-certified manufacturers, batch-traced from manufacturer → warehouse bin → your doorstep, and recalled instantly if any batch is flagged.",
            },
        ]}
    />
);

export default GenericMedicines;
